import {
    registerUrl,
    provinceUrl,
    cityUrl,
    validEmailUrl
} from 'Utils/urlUtil'
import { post, get } from 'Utils/apiUtil'

export const GET_REGISTER = "GET_REGISTER"
export const PROVINCE_LIST = 'PROVINCE_LIST'
export const SHIPTO_CITY_LIST = 'SHIPTO_CITY_LIST'
export const BILLTO_CITY_LIST = 'BILLTO_CITY_LIST'
export const EMAIL_VALID_REGISTER = 'EMAIL_VALID_REGISTER'

// Send to backend request Register
export function register(params,func) {
    return dispatch => dispatch(post(registerUrl, params)).then((res) => {
        dispatch({ type: GET_REGISTER, payload: res });
        func && func(res)
    }).catch((res) => {
        dispatch({ type: GET_REGISTER, payload: res });
        func && func(res)
    });
}

export const getProvinceList = () => {
    return dispatch => dispatch(get(provinceUrl, dispatch)).then(res => {
        dispatch({ type: PROVINCE_LIST, payload: res });
    }).catch((res) => {
        dispatch({ type: PROVINCE_LIST, payload: res });
    });
}

export const getCityList = (provinceId, type) => {
    switch(type) {
        case 'shipTo':
            type = SHIPTO_CITY_LIST;
            break;
        case 'billTo':
            type = BILLTO_CITY_LIST;
            break;
        default:
    }

    return dispatch => dispatch(get(cityUrl, { provinceId })).then(res => {
        dispatch({ type, payload: res });
    }).catch((res) => {
        dispatch({ type, payload: res });
    });
}

export function validEmailRegister (params, func) {
    return (dispatch) => dispatch(get(validEmailUrl, { email: params, type: 1 })).then((res) => {
        dispatch({ type: EMAIL_VALID_REGISTER, payload: res });
        func && func(res)
    }).catch((res) => {
        dispatch({ type: EMAIL_VALID_REGISTER, payload: res });
        func && func(res)
    });
}
